import { render, staticRenderFns } from "./DisciplinaryEdit.vue?vue&type=template&id=a396af88"
import script from "./DisciplinaryEdit.vue?vue&type=script&lang=js"
export * from "./DisciplinaryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports